import React from 'react';
import { Link } from 'react-router-dom';
import URI from 'urijs';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';

// images
import notfound from './images/notfound.png';

// modules
import styles from '../Containers.module.scss';

const PHOTO_BASE_URL = '//poiphotos.naplesarea.com/';

function POIResult({ record }) {
  const id = record.name.replace(/(\s)/g, '-');
  return (
    <tr className={styles.result}>
      <td className={cx(BS.textCenter, BS.dNone, BS.dMdTableCell)}>
        <img
          src={record.photo ? `${PHOTO_BASE_URL}${record.photo}` : notfound}
          alt={`${record.name}`}
          onError={e => {
            e.target.src = notfound;
            e.target.className = cx(e.target.className, BS.b1);
          }}
          className={cx({
            [BS.b1]: !record.photo
          })}
        />
      </td>
      <td>
        <div className={cx(BS.textCenter, BS.dMdNone, BS.pb1)}>
          <h6>
            <Link to={URI(`/poi/${id}`).toString()}>{record.name}</Link>
          </h6>
          <img
            src={record.photo ? `${PHOTO_BASE_URL}${record.photo}` : notfound}
            alt={`${record.name}`}
            onError={e => {
              e.target.src = notfound;
              e.target.className = cx(e.target.className, BS.b1);
            }}
            className={cx({
              [BS.b1]: !record.photo
            })}
          />
        </div>
        <h6 className={cx(BS.dNone, BS.dMdBlock)}>
          <Link to={URI(`/poi/${id}`).toString()}>{record.name}</Link>
        </h6>
        <p
          style={{ overflow: 'hidden' }}
          dangerouslySetInnerHTML={{
            __html: record.description
          }}
        />
        <p>
          <Link to={URI(`/poi/${id}`).toString()}>View Details and Nearby Listings</Link>
        </p>
      </td>
    </tr>
  );
}

export default POIResult;



// WEBPACK FOOTER //
// ./src/containers/POISearch/POISearchResult.js